import * as React from 'react';

import { useRecommendedPackagesPaymentStatus } from './hooks';

import { RecommendedPackagesPaymentStatus } from './RecommendedPackagesPaymentStatus';

export const RecommendedPackagesPaymentStatusContainer = () => {
  const { isRender, status, handleRetryClick } = useRecommendedPackagesPaymentStatus();

  if (!isRender) {
    return null;
  }

  return <RecommendedPackagesPaymentStatus status={status} handleRetryClick={handleRetryClick} />;
};
